<div
    class="bazis-datetime-control"
    #inputDate
    clickOutside
    (clickOutside)="clickPopperOutside()"
    [excludeElement]="calendar"
>
    <div class="bazis-control__field-group__start">
        <bazis-button
            fill="clear"
            #generalBtn
            (click)="openCalendar($event)"
        >
            <bazis-icon
                *ngIf="sideIcon === 'left'"
                slot="start"
                [name]="icons.date"
                size="compact"
                class="bh-margin-end-3x"
            ></bazis-icon>
            <span class="bazis-control__field_decor">
                {{ buttonValue }}
            </span>
            <bazis-icon
                *ngIf="sideIcon === 'right'"
                slot="end"
                [name]="icons.date"
                size="compact"
                class="bh-margin-start-3x"
            ></bazis-icon>
        </bazis-button>
    </div>
    <div
        class="bh-popper-z-index"
        #calendar
        [hidden]="!showCalendar"
        (click)="clickPopper()"
    >
        <bazis-datepicker
            *ngIf="showCalendar"
            [value]="calendarValue"
            (valueChange)="setValueFromCalendar($event)"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [startYear]="startYear"
            [canToggleDay]="canToggleDay"
            [formatOutput]="displayFormat"
            [viewConfig]="datapickerViewConfig"
        ></bazis-datepicker>
    </div>
</div>
